// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Data from "common/src/data/Data.bs.js";
import * as React from "react";
import * as TftSet from "common/src/data/TftSet.bs.js";
import * as ItemImage from "common/src/tft-static/ItemImage.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as ItemTooltip from "common/src/tft-static/ItemTooltip.bs.js";
import * as Translation from "common/src/bindings/Translation.bs.js";
import * as ContentSection from "common/src/ContentSection.bs.js";
import * as RitoDescription2 from "common/src/components/RitoDescription2.bs.js";

function SupItems$ItemCard(Props) {
  var itemId = Props.itemId;
  var info = Props.info;
  var set = TftSet.use(undefined);
  var itemsT = Translation.useT(/* Items */3);
  var tmp;
  if (info.from.length === 2) {
    var c0 = Belt_Array.getExn(info.from, 0);
    var match = Belt_Array.getExn(Data.itemsArr(set), c0 - 1 | 0);
    var id0 = match[0];
    var c1 = Belt_Array.getExn(info.from, 1);
    var match$1 = Belt_Array.getExn(Data.itemsArr(set), c1 - 1 | 0);
    var id1 = match$1[0];
    tmp = React.createElement("div", {
          className: "flex items-center ml-auto"
        }, React.createElement(ItemTooltip.make, {
              itemId: id0,
              children: React.createElement(ItemImage.make, {
                    itemId: id0,
                    size: 22
                  })
            }), React.createElement("div", {
              className: "px-[3px]"
            }, "+"), React.createElement(ItemTooltip.make, {
              itemId: id1,
              children: React.createElement(ItemImage.make, {
                    itemId: id1,
                    size: 22
                  })
            }));
  } else {
    tmp = null;
  }
  return React.createElement(ContentSection.make, {
              children: null
            }, React.createElement("div", {
                  className: "flex items-start gap-2 pb-2"
                }, React.createElement(ItemImage.make, {
                      itemId: itemId,
                      size: 36,
                      rounded: "rounded"
                    }), React.createElement("div", undefined, React.createElement("div", {
                          className: "pb-1"
                        }, itemsT(itemId)), React.createElement(ItemTooltip.BaseStats.make, {
                          item: info
                        })), tmp), React.createElement(RitoDescription2.make, {
                  desc: itemsT(itemId + "_desc"),
                  className: "text-sm leading-tight"
                }));
}

var ItemCard = {
  make: SupItems$ItemCard
};

function SupItems(Props) {
  Translation.useT(/* Common */0);
  Translation.useT(/* Units */1);
  Translation.useT(/* Traits */2);
  return React.createElement("div", {
              id: "set-update-items"
            });
}

var make = SupItems;

export {
  ItemCard ,
  make ,
  
}
/* Data Not a pure module */
